"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var text_encoding_1 = require("file2html/lib/text-encoding");
var sax_1 = require("file2html-xml-tools/lib/sax");
function parseDocumentContent(fileContent, meta) {
    var content = '';
    var isDocumentInfo;
    var isAuthorTag;
    var isContent;
    var isTextContentEnabled;
    var openedHTMLTags = {
        a: '<a',
        p: '<p',
        section: '<section',
        epigraph: '<div',
        poem: '<div',
        stanza: '<div',
        v: '<div',
        cite: '<cite',
        title: '<header',
        image: '<img'
    };
    var unfinishedTagEnding = '>';
    var closedHTMLTags = {
        a: '</a>',
        p: '</p>',
        section: '</section>',
        epigraph: '</div>',
        poem: '</div>',
        stanza: '</div>',
        v: '</div>',
        cite: '</cite>',
        title: '</header>'
    };
    var textContentTags = [
        'a',
        'p',
        'v'
    ];
    var contentTags = textContentTags.concat([
        'section',
        'epigraph',
        'poem',
        'stanza',
        'cite',
        'title'
    ]);
    var imageTagSource;
    sax_1.parseXML(text_encoding_1.decode(fileContent), {
        onopentag: function (tagName, attributes) {
            switch (tagName) {
                case 'document-info':
                    isDocumentInfo = true;
                    break;
                case 'date':
                    if (isDocumentInfo) {
                        var value = attributes.value;
                        if (value) {
                            meta.createdAt = value;
                        }
                    }
                    break;
                case 'nickname':
                    if (isDocumentInfo) {
                        isAuthorTag = true;
                    }
                    break;
                case 'body':
                    isContent = true;
                    break;
                case 'image':
                    var href = void 0;
                    for (var key in attributes) {
                        if (attributes.hasOwnProperty(key) && key.split(':')[1] === 'href') {
                            href = attributes[key];
                            break;
                        }
                    }
                    if (isContent && href) {
                        content += openedHTMLTags.image + ' src="' + href + '"/' + unfinishedTagEnding;
                    }
                    break;
                case 'binary':
                    var id = attributes['id'];
                    var contentType = attributes['content-type'];
                    if (id && contentType) {
                        imageTagSource = { id: id, contentType: contentType };
                    }
                    break;
                case 'empty-line':
                    if (isContent) {
                        content += '<br/>';
                    }
                    break;
                default:
                    if (isContent && contentTags.indexOf(tagName) >= 0) {
                        content += openedHTMLTags[tagName] + " class=\"" + tagName + "\"";
                        isTextContentEnabled = textContentTags.indexOf(tagName) >= 0;
                        if (tagName === 'a') {
                            for (var key in attributes) {
                                if (attributes.hasOwnProperty(key) && key.split(':')[1] === 'href') {
                                    content += " href=\"" + attributes[key] + "\"";
                                    break;
                                }
                            }
                            content += unfinishedTagEnding;
                        }
                        else if (tagName === 'section') {
                            var id_1 = attributes.id;
                            content += unfinishedTagEnding;
                            if (id_1) {
                                // add anchor: <a name=""></a>
                                content += openedHTMLTags.a + " name=\"" + id_1 + "\"" + unfinishedTagEnding;
                                content += closedHTMLTags.a;
                            }
                        }
                        else {
                            content += unfinishedTagEnding;
                        }
                    }
            }
        },
        onclosetag: function (tagName) {
            switch (tagName) {
                case 'document-info':
                    isDocumentInfo = false;
                    break;
                case 'nickname':
                    if (isDocumentInfo) {
                        isAuthorTag = false;
                    }
                    break;
                case 'body':
                    isContent = false;
                    break;
                default:
                    if (isContent && contentTags.indexOf(tagName) >= 0) {
                        content += closedHTMLTags[tagName];
                        isTextContentEnabled = false;
                    }
            }
        },
        ontext: function (textContent) {
            if (isAuthorTag) {
                meta.creator += textContent;
            }
            else if (imageTagSource) {
                content = content.replace(new RegExp("src=\"#" + imageTagSource.id + "\"", 'g'), "src=\"data:" + imageTagSource.contentType + ";base64," + textContent.trim() + "\"");
                imageTagSource = undefined;
            }
            else if (isTextContentEnabled) {
                content += textContent;
            }
        }
    });
    return Promise.resolve({
        styles: '<style></style>',
        content: "<div>" + content + "</div>"
    });
}
exports.parseDocumentContent = parseDocumentContent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/file2html-fiction-book/lib/parse-document-content.js
// module id = 1755
// module chunks = 0